import moment from 'moment-timezone';
import type { StringDate } from '../../types';

moment.tz.setDefault('America/Sao_Paulo');

export const formatISODateToString = (
  date: Date | string,
  format = 'DD/MM/YYYY',
): string => {
  return moment(date).format(format);
};

export const formatISODatetimeToString = (
  date: Date | string,
  separator = ' ',
): string => {
  const formattedDate = moment(date).format('DD/MM/YYYY');
  const formattedDateTime = moment(date).format('HH:mm');

  return `${formattedDate}${separator}${formattedDateTime}`;
};

export const formatUniversalISODatetimeToString = (date: Date): string => {
  return date.toISOString()?.split('T')?.[0];
};

export const dateString = (date: Date = new Date()): StringDate =>
  moment(date).format('YYYY-MM-DD');

export const dateTimeString = (date: string | Date = new Date()): string =>
  moment(date).toISOString();

export const diffInDays = (date1: Date, date2: Date) => {
  const m1 = moment(date1).startOf('day');
  const m2 = moment(date2).startOf('day');
  return m2.diff(m1, 'days');
};
